module.exports = __webpack_public_path__ + "img/bnr.319c3c3a.png";